import bedrock from "../../doctrine/mirror-bedrock-v1.json";
import { MirrorResultSchema, type MirrorResult } from "./product";

export const MIRROR_BEDROCK = bedrock;
export const MIRROR_GOVERNING_INVARIANT = bedrock.governing_invariant;

export type MirrorLanguageViolation =
  | { kind: "forbidden_term"; value: string }
  | { kind: "metaphysical_causality"; value: string }
  | { kind: "guaranteed_outcome"; value: string }
  | { kind: "identity_verdict"; value: string };

const FORBIDDEN_TERMS = bedrock.customer_output.forbidden_terms.map((term) => term.toLowerCase());

const METAPHYSICAL_CAUSALITY = [
  /\b(?:your|the)\s+(?:thoughts?|words?|fear|resentment)\b.{0,50}\b(?:caused|created|made)\b.{0,40}\b(?:illness|disease|accident|event|outcome)\b/i,
  /\b(?:fear|resentment)\b.{0,40}\b(?:causes?|caused|creates?|created)\b.{0,30}\b(?:illness|disease)\b/i,
];

const GUARANTEED_OUTCOME = [
  /\b(?:the universe|divine law|god)\b.{0,50}\b(?:will|must|guarantees?|ensures?)\b/i,
  /\b(?:will definitely|is guaranteed to|must)\s+manifest\b/i,
];

const IDENTITY_VERDICT = [
  /\bthis (?:proves|shows|means) (?:who|what) you are\b/i,
  /\b(?:you are|you have|you suffer from)\b.{0,40}\b(?:self-sabotag\w*|rejection sensitivity|abandonment anxiety|pathology)\b/i,
];
export function collectMirrorLanguageViolations(text: string): MirrorLanguageViolation[] {
  const lower = text.toLowerCase();
  const violations: MirrorLanguageViolation[] = [];

  for (const term of FORBIDDEN_TERMS) {
    if (lower.includes(term)) violations.push({ kind: "forbidden_term", value: term });
  }
  for (const pattern of METAPHYSICAL_CAUSALITY) {
    const match = text.match(pattern);
    if (match) violations.push({ kind: "metaphysical_causality", value: match[0] });
  }
  for (const pattern of GUARANTEED_OUTCOME) {
    const match = text.match(pattern);
    if (match) violations.push({ kind: "guaranteed_outcome", value: match[0] });
  }
  for (const pattern of IDENTITY_VERDICT) {
    const match = text.match(pattern);
    if (match) violations.push({ kind: "identity_verdict", value: match[0] });
  }

  return violations;
}

export function mirrorGeneratedText(result: MirrorResult): string[] {
  const text = [result.mirror];
  if ("question" in result) text.push(result.question);
  if ("correction" in result && result.correction) text.push(result.correction.text);
  if ("move" in result && result.move) text.push(result.move.text);
  if ("alignment_explanation" in result) text.push(result.alignment_explanation);
  return text;
}
export function validateMirrorResultLanguage(result: MirrorResult): MirrorLanguageViolation[] {
  return mirrorGeneratedText(result).flatMap(collectMirrorLanguageViolations);
}

export function mirrorLanguageFallback(requestId: string): MirrorResult {
  return MirrorResultSchema.parse({
    request_id: requestId,
    result_type: "uncertain",
    confidence: 0.25,
    persistent_memory: false,
    mirror: "I may be reading too much into that.",
    question: "Does that fit?",
  });
}

export function enforceMirrorBedrock(result: MirrorResult): MirrorResult {
  return validateMirrorResultLanguage(result).length === 0
    ? result
    : mirrorLanguageFallback(result.request_id);
}
